import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Grid,
} from '@mui/material';
import { anos } from '../../data/mockData';

function SelecaoAnoMes({ onSelecionar }) {
  const [anoSelecionado, setAnoSelecionado] = useState('');

  const handleConfirmar = () => {
    if (anoSelecionado) {
      onSelecionar(anoSelecionado);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 500,
          width: '100%',
        }}
      >
        <Typography variant="h5" gutterBottom sx={{ mb: 3, fontWeight: 'bold' }}>
          Selecionar Ano
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Ano</InputLabel>
              <Select
                value={anoSelecionado}
                label="Ano"
                onChange={(e) => setAnoSelecionado(e.target.value)}
              >
                {anos.map((ano) => (
                  <MenuItem key={ano} value={ano}>
                    {ano}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              fullWidth
              size="large"
              onClick={handleConfirmar}
              disabled={!anoSelecionado}
              sx={{ mt: 2 }}
            >
              Confirmar
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}

export default SelecaoAnoMes;

